import useAdminDataStore, { selectCurrentGroupData } from "../store/adminData/adminData";
import useUserStore from "../store/user/user";
import { fbAuth } from "../services/firebaseService/connection";
import { useEffect, useState } from "react";

const useUserRole = () => {
  const userRoles = useUserStore((state) => state.user.userRoles);
  const groupData = useAdminDataStore(selectCurrentGroupData);
  const [userRoleLoading, setUserRoleLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getUserRole = async () => {
      try {
        setUserRoleLoading(true);
        setError(null);

        if (!fbAuth?.currentUser) {
          setUserRole(null);
          return;
        }

        const idTokenResult = await fbAuth.currentUser.getIdTokenResult();
        const isSuperadmin = idTokenResult.claims.superadmin === true;

        if (isSuperadmin) {
          setUserRole("superadmin");
        } else if (groupData?.id) {
          const role = userRoles?.[groupData.id] || null;
          setUserRole(role);
        } else {
          setUserRole(null);
        }
      } catch (err) {
        console.error("Error getting user role:", err);
        setError(err);
        setUserRole(null);
      } finally {
        setUserRoleLoading(false);
      }
    };

    getUserRole();
  }, [groupData?.id, userRoles, fbAuth?.currentUser]); // eslint-disable-line react-hooks/exhaustive-deps

  return { userRole, userRoleLoading, error };
};

export default useUserRole;
